<template>
    <div class="dev-list">
        <div class="dev-list-search">
            <div class="search-btn">
                <div style="display: flex;flex-direction: row;">
                    <el-button size="small" type="primary" @click="addUserProcess()"
                               v-if="$store.getters.checkChangeAuth()">添加用户
                    </el-button>
                    <div class="search-main-item" style="margin-left: 10px">
                        <div class="item-input">
                            <el-select v-model="searchInfo.groupId" size="small" @change="getUserListForSearch"
                                       placeholder="用户组">
                                <el-option
                                        v-for="item in searchOptions.userGroupOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div @keyup.enter="getUserListForSearch">
                    <el-input size="small" placeholder="输入用户名 搜索" v-model="searchInfo.username" style="width: 320px">
                        <el-button slot="append" icon="el-icon-search" @click="getUserListForSearch"></el-button>
                    </el-input>
                </div>
                <!--<el-button type="text" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>-->
            </div>
        </div>
        <div class="device-case-dev border-all">
            <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini" @row-click="checkRow"
                      tooltip-effect="dark" style="width: 99%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" header-align="center"></el-table-column>
                <el-table-column type="index" label="ID"></el-table-column>
                <el-table-column prop="username" label="用户名"></el-table-column>
                <el-table-column label="用户组">
                    <template slot-scope="scope">
                        {{scope.row.groupName}}
                    </template>
                </el-table-column>
                <el-table-column prop="deadlineTime" label="到期时间">
                    <template slot-scope="scope">
                        <span style="color: red" v-if="scope.row.isDel === 1">{{ scope.row.aging === -1 ? '永久' : formatTime(scope.row.deadlineTime)}}</span>
                        <span style="color: green" v-else-if="scope.row.aging === -1">永久</span>
                        <span v-else>{{formatTime(scope.row.deadlineTime)}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column label="剩余有效期">-->
                    <!--<template slot-scope="scope">-->
                        <!--{{scope.row.aging > 0 ? (scope.row.ttl ? scope.row.ttl : 0) : -1 | ttlToDays}}-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="changeUserPop(scope.row)"
                                   v-if="$store.getters.checkChangeAuth() && scope.row.isDel !== 1">修改
                        </el-button>
                        <el-button type="text" size="small" @click="resetUserGoogleAuthenticator(scope.row)"
                                   v-if="scope.row.isDel !== 1 && ($store.getters.checkChangeAuth() || $store.state.userInfo.groupType === 1)">重置验证
                        </el-button>
                        <el-button type="text" size="small" @click="changeUserTTL(scope.row)"
                                   v-if="scope.row.isDel !== 1 && ($store.getters.checkChangeAuth() || $store.state.userInfo.groupType === 1)"
                                   :disabled="scope.row.aging === -1">延长有效期
                        </el-button>
                        <el-button type="text" size="small" @click="reuseUser(scope.row)" v-if="$store.getters.checkChangeAuth() && scope.row.isDel === 1">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn">
                    <el-button size="small" :disabled="multipleSelection.length === 0" plain @click="deleteCaseBatch">
                        删除
                    </el-button>
                </div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
            <!-- 添加用户 -->
            <Drawer title="添加用户" :visible.sync="addUserPopShow" @handClick="addUser">
                <!--<el-dialog title="添加用户" :append-to-body="true" :visible.sync="addUserPopShow" width="500px" top="15vh">-->
                <div>
                    <el-form ref="form" :model="addUserInfo" label-width="130px" label-position="left">
                        <el-form-item size="mini" label="用户名">
                            <el-input v-model="addUserInfo.username" autocomplete="new-username"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="密码">
                            <el-input v-model="addUserInfo.password" type="password"
                                      autocomplete="new-password"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="确认密码">
                            <el-input v-model="addUserInfo.password2" type="password"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="用户组">
                            <el-select v-model="addUserInfo.groupId" placeholder="请选择" @change="changeGroupList">
                                <el-option
                                        v-for="item in searchOptions.userGroupOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item size="mini" label="账号时效">
                            <el-select v-model="addUserInfo.aging" placeholder="请选择">
                                <el-option
                                        v-for="item in accountActiveTime"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item size="mini" label="分配IP代理" v-if="groupTypeClass['id' + addUserInfo.groupId] == 2">
                        </el-form-item>

                        <el-table v-if="groupTypeClass['id' + addUserInfo.groupId] == 2"
                                  ref="ipProxyMultipleTable"
                                  :data="ipProxyList"
                                  size="mini"
                                  highlight-current-row
                                  :height="ipProxyTableHeight"
                                  style="width: 100%"
                                  @selection-change="handleIpProxySelectionChange"
                        >
                            <el-table-column
                                    type="selection"
                                    width="50">
                            </el-table-column>
                            <el-table-column prop="name" label="名称"></el-table-column>
                            <!--<el-table-column prop="ip" label="IP"></el-table-column>-->
                            <el-table-column
                                    prop="connectionLast"
                                    label="剩余连接数"
                            ></el-table-column>
                            <el-table-column
                                    prop="proxyTypeText"
                                    label="隧道协议"
                                    :formatter="proxyTypeFormat"
                            >
                            </el-table-column>
                        </el-table>
                        <div class="ipproxy-list-bottom" v-if="groupTypeClass['id' + addUserInfo.groupId] == 2">
                            <div class="list-bottom-btn"></div>
                            <el-pagination
                                    @size-change="ipProxySizeChangeHandle"
                                    @current-change="ipProxyCurrentChangeHandle"
                                    :current-page="ipProxyPage.startPage"
                                    :page-sizes="[10, 20, 50]"
                                    :page-size="ipProxyPage.limit"
                                    :pager-count="5"
                                    layout="total, sizes, prev, pager, next"
                                    :total="ipProxyInfo.total"
                            >
                            </el-pagination>
                        </div>
                        <!--<div class="ipproxy-list-bottom" v-if="groupTypeClass['id' + addUserInfo.groupId] == 2">-->
                            <!--<el-pagination-->
                                    <!--layout="total"-->
                                    <!--:total="ipProxyList.length">-->
                            <!--</el-pagination>-->
                        <!--</div>-->
                    </el-form>
                </div>
            </Drawer>
            <!-- 修改用户 -->
            <Drawer title="修改用户" :visible.sync="changeUserPopShow" @handClick="changeUser">
                <!--<el-dialog title="修改用户" :append-to-body="true" :visible.sync="changeUserPopShow" width="500px" top="15vh">-->
                <el-form ref="form" :model="changeUserInfo" label-width="130px" label-position="left">
                    <el-form-item size="mini" label="用户名">
                        <span>{{changeUserInfo.username}}</span>
                    </el-form-item>
                    <el-form-item size="mini" label="用户组">
                        <el-select v-model="changeUserInfo.groupId" placeholder="请选择" @change="changeGroupList2">
                            <el-option
                                    v-for="item in searchOptions.userGroupOption"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item size="mini" label="账号时效">
                        <el-select v-model="changeUserInfo.aging" :disabled="true">
                            <el-option
                                    v-for="item in accountActiveTime"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item size="mini" label="分配IP代理"
                                  v-if="groupTypeClass['id' + changeUserInfo.groupId] == 2">
                    </el-form-item>
                    <el-table v-if="groupTypeClass['id' + changeUserInfo.groupId] == 2"
                              ref="ipProxyMultipleTable2"
                              :data="ipProxyList"
                              size="mini"
                              tooltip-effect="dark"
                              highlight-current-row
                              :max-height="ipProxyTableHeight2"
                              style="width: 100%;"
                              @selection-change="handleIpProxySelectionChange"
                    >
                        <el-table-column
                                type="selection"
                                width="50">
                        </el-table-column>
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <!--<el-table-column prop="ip" label="IP"></el-table-column>-->
                        <el-table-column
                                prop="connectionLast"
                                label="剩余连接数"
                        ></el-table-column>
                        <el-table-column
                                prop="proxyTypeText"
                                label="隧道协议"
                                :formatter="proxyTypeFormat"
                        >
                        </el-table-column>
                    </el-table>
                    <div class="ipproxy-list-bottom" v-if="groupTypeClass['id' + changeUserInfo.groupId] == 2">
                        <div class="list-bottom-btn"></div>
                        <el-pagination
                                @size-change="ipProxySizeChangeHandle"
                                @current-change="ipProxyCurrentChangeHandle"
                                :current-page="ipProxyPage.startPage"
                                :page-sizes="[10, 20, 50]"
                                :page-size="ipProxyPage.limit"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next"
                                :total="ipProxyInfo.total"
                        >
                        </el-pagination>
                    </div>
                    <!--<div class="ipproxy-list-bottom" v-if="groupTypeClass['id' + changeUserInfo.groupId] == 2">-->
                        <!--<el-pagination-->
                                <!--layout="total"-->
                                <!--:total="ipProxyList.length">-->
                        <!--</el-pagination>-->
                    <!--</div>-->
                </el-form>
            </Drawer>
            <!-- 修改备注弹窗 -->
            <Drawer
                    title="延长有效期"
                    :visible.sync="changeUserTTLPopShow"
                    @handClick="changeUserTTLProcess"
            >
                <el-form size="mini" label-width="140px"
                         label-position="left">
                    <el-form-item style="color: #333;" label="用户名：">{{ userTTLInfo.username }}</el-form-item>
                    <el-form-item style="color: #333;" label="用户组：">{{ userTTLInfo.groupname }}</el-form-item>
                    <el-form-item label="剩余有效期：" style="color: #333;">{{ userTTLInfo.ttl | ttlToDays}}</el-form-item>
                    <el-form-item label="延长有效期时间：" style="color: #333;">
                        <el-input-number v-model.trim="addTTL" controls-position="right" @change="handleTTLChange" :min="0"
                                         :max="100" size="mini"></el-input-number>
                        <span style="margin-left: 10px; color: #333;">天</span>
                    </el-form-item>

                </el-form>
            </Drawer>
            <Drawer
                    title="过期账号启用"
                    :visible.sync="reuseUserPopShow"
                    @handClick="reuseUserProcess"
            >
                <el-form size="mini" label-width="140px"
                         label-position="left">
                    <el-form-item style="color: #333;" label="用户名：">{{ reuseUserInfo.username }}</el-form-item>
                    <el-form-item style="color: #333;" label="用户组：">{{ reuseUserInfo.groupname }}</el-form-item>
                    <el-form-item label="到期时间：" style="color: red;">{{ reuseUserInfo.deadlineTime | formatDateTime}}</el-form-item>
                    <el-form-item label="重置有效时间：" style="color: #333;">
                        <el-input-number v-model.trim="reuseAging" controls-position="right" :min="0"
                                         :max="100" size="mini"></el-input-number>
                        <span style="margin-left: 10px; color: #333;">天</span>
                    </el-form-item>

                </el-form>

            </Drawer>
        </div>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import { formatTimeMixin } from '@/mixin'

    export default {
        name: "UserList",
        components: {Drawer},
        data() {
            return {
                addTTL: 0,
                reuseAging: 0,
                ipProxyList: [],
                ipProxyInfo:{},
                userIpProxy: [],
                ipProxySelection: [],
                tableHeight: 0,
                ipProxyTableHeight: 0,
                ipProxyTableHeight2: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                ipProxyPage: {
                    startPage: 1,
                    limit: 10
                },
                multipleSelection: [],
                addUserPopShow: false, // 显示手动添加弹窗
                addUserInfo: {
                    username: "",
                    password: "",
                    password2: "",
                    groupId: "",
                    aging: -1,
                    proxyIds: []
                },
                changeUserPopShow: false, // 显示修改用户弹窗
                changeUserInfo: {
                    id: "",
                    username: "",
                    groupId: "",
                    aging: -1
                },
                changeUserTTLPopShow: false, //显示延长有效期弹窗
                userTTLInfo: {
                    id: "",
                    username: "",
                    groupname: "",
                    ttl: 0
                },

                reuseUserPopShow: false,//显示到期账号启用弹窗
                reuseUserInfo: {
                    id: "",
                    username: "",
                    groupname: "",
                    deadlineTime: 0
                },
                searchInfo: {
                    username: "",
                    groupId: ""
                },
                searchOptions: {
                    userGroupOption: []
                },
                accountActiveTime: [{
                    label: '永久',
                    value: -1
                }, {
                    label: '3天',
                    value: 3
                }, {
                    label: '7天',
                    value: 7
                }, {
                    label: '15天',
                    value: 15
                }, {
                    label: '30天',
                    value: 30
                }],
                groupClass: {},
                groupTypeClass: {}
            }
        },
        mixins: [formatTimeMixin],
        filters: {
            ttlToDays(val) {
                if (val > 0) {
                    return Math.floor(val / (3600*24)) + '天' + Math.floor(val % (3600*24) / 3600) + '小时'
                } else if (val == 0) {
                    return "无"
                } else {
                    return "永久"
                }
            },
        },
        computed: {
            groupName(val) {
                return this.groupClass["id" + val]
            },
        },
        methods: {
            handleTTLChange(val) {
                // console.log("val is " + val)
            },
            changeGroupList(val) {
                // console.log("changeGroupList val " + val)
                if (this.groupTypeClass['id' + this.addUserInfo.groupId] == 2) {
                    this.$nextTick().then(() => {
                        this.ipProxyTableHeight = window.innerHeight - this.$refs.ipProxyMultipleTable.$el.offsetTop - 100;
                    })
                }
            },
            changeGroupList2(val) {
                // console.log("changeGroupList2 val " + val)
                if (this.groupTypeClass['id' + this.changeUserInfo.groupId] == 2) {
                    this.$nextTick().then(() => {
                        this.ipProxyTableHeight2 = window.innerHeight - this.$refs.ipProxyMultipleTable2.$el.offsetTop - 100;
                        this.userIpProxy.forEach(userProxy => {
                            this.ipProxyList.forEach(ipProxy => {
                                if (userProxy.id == ipProxy.id) {
                                    this.$refs.ipProxyMultipleTable2.toggleRowSelection(ipProxy, true)
                                }
                            })
                        })
                    })
                }
            },
            handleIpProxySelectionChange(val) {
                // console.log("val is " + val)
                this.ipProxySelection = val
                // console.log("handleSelectionChange " + JSON.stringify(val))
            },
            proxyTypeFormat(row, column) {
                if (row.proxyType === 2) {
                    return "PPTP";
                } else if (row.proxyType === 3) {
                    return "L2TP";
                } else if (row.proxyType === 4) {
                    return "Socks5";
                } else if (row.proxyType === 5) {
                    return "http";
                } else if (row.proxyType === 6) {
                    return "ssr";
                } else if (row.proxyType === 7) {
                    return "Socks5(UDP)";
                } else {
                    return "OpenVPN";
                }
            },
            addUserProcess() {
                this.addUserInfo = {
                    username: "",
                    password: "",
                    password2: "",
                    groupId: "",
                    aging: -1,
                    proxyIds: []
                }
                this.getIpPorxyList()
                this.addUserPopShow = true
                if (this.groupTypeClass['id' + this.addUserInfo.groupId] == 2) {
                    this.$nextTick().then(() => {
                        this.ipProxyTableHeight = window.innerHeight - this.$refs.ipProxyMultipleTable.$el.offsetTop - 100;
                    })
                }
            },
            getIpPorxyList() {
                let that = this;
                this.ipProxyList = []
                let params = JSON.parse(JSON.stringify(this.ipProxyPage))
                that.$post(that.$uri.ipProxy.list, params).then(res => {
                    if (res.success) {
                        // console.log("res is " + JSON.stringify(res))
                        that.ipProxyList = res.list
                        that.ipProxyInfo = res
                        // console.log("ipProxyList is " + JSON.stringify(that.ipProxyList))
                    }
                });
            },
            getUserIpProxy(userId) {
                let that = this;
                this.userIpProxy = []
                that.$post(that.$uri.ipProxy.list, {userId: userId}).then(res => {
                    if (res.success) {
                        that.userIpProxy = res.list
                        // console.log("userIpProxy is " + JSON.stringify(that.userIpProxy))
                        that.$nextTick().then(() => {
                            that.userIpProxy.forEach(userProxy => {
                                that.ipProxyList.forEach(ipProxy => {
                                    if (userProxy.id == ipProxy.id) {
                                        that.$refs.ipProxyMultipleTable2.toggleRowSelection(ipProxy, true)
                                    }
                                })
                            })
                        })
                    }
                });
            },
            changeUserTTL(row) {
                this.userTTLInfo.id = row.id
                this.userTTLInfo.username = row.username
                this.userTTLInfo.groupname = row.groupName
                this.userTTLInfo.ttl = row.ttl ? row.ttl : 0
                
                this.changeUserTTLPopShow = true
            },
            changeUserTTLProcess() {
                let that = this
                // console.log("resetGoogleAuthenticator for " + row.id)
                that.$post(that.$uri.user.ttl, {id: that.userTTLInfo.id, ttl: that.addTTL * 3600 * 24}).then(res => {
                    // console.log("resetGoogleAuthenticator res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("延长有效时间成功")
                        that.getUserList()
                    } else {
                        that.$message.error("延长有效时间失败")
                    }
                }).finally(()=>{
                    that.changeUserTTLPopShow = false
                })
            },
            reuseUser(row) {
                this.reuseUserInfo.id = row.id
                this.reuseUserInfo.username = row.username
                this.reuseUserInfo.groupname = row.groupName
                this.reuseUserInfo.deadlineTime = row.deadlineTime
                
                this.reuseUserPopShow = true
            },
            reuseUserProcess() {
                let that = this
                // console.log("resetGoogleAuthenticator for " + row.id)
                that.$post(that.$uri.user.reuse, {id: that.reuseUserInfo.id, aging: that.reuseAging}).then(res => {
                    // console.log("resetGoogleAuthenticator res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("启用账号成功")
                        that.getUserList()
                    } else {
                        that.$message.error("启用账号失败")
                    }
                }).finally(()=>{
                    that.reuseUserPopShow = false
                })
            },
            resetUserGoogleAuthenticator(row) {
                let that = this
                this.$confirm("重置验证后原有的安全验证将无法使用，点击确定后将退出系统重新登录进行绑定。", "确认要重置验证绑定吗？", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-yellow',
                    cancelButtonText: '取消'
                }).then(() => {
                    // console.log("resetGoogleAuthenticator for " + row.id)
                    that.$post(that.$uri.user.resetGoogleAuthenticator, {id: row.id}).then(res => {
                        // console.log("resetGoogleAuthenticator res " + JSON.stringify(res))
                        if (res.success) {
                            that.$message.success("重置完成")
                        } else {
                            that.$message.error("重置失败")
                        }
                    })

                }).catch(() => {
                })
                // this.$message.success("重置完成")
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 删除设备池 */
            async deleteCase(id) {
                let that = this
                await that.$post(that.$uri.user.delete, {id})
            },
            /* 批量删除设备池 */
            deleteCaseBatch() {
                this.$confirm("删除后用户将无法登录系统？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-yellow',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.multipleSelection.forEach(v => {
                        this.deleteCase(v.id)
                    })
                    this.$message.success("删除完成")
                    let that = this
                    setTimeout(() => {
                        that.getUserList()
                    }, 1000)
                }).catch(() => {
                })
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            /* 获取用户列表 */
            getUserList() {
                this.$post(this.$uri.user.list, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    // console.log("userList is " + JSON.stringify(res))
                })
            },
            getUserListForSearch() {
                this.page.startPage = 1
                this.$post(this.$uri.user.list, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    // console.log("userList is " + JSON.stringify(res))
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getUserList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getUserList()
            },
            /* 当前页改变 */
            ipProxyCurrentChangeHandle(val) {
                this.ipProxyPage.startPage = val
                this.getIpPorxyList()
            },
            /* 每页条数改变 */
            ipProxySizeChangeHandle(val) {
                this.ipProxyPage.limit = val
                this.getIpPorxyList()
            },
            /* 获得用户组组信息 */
            getGroupList() {
                let that = this
                that.$post(that.$uri.user.groupList, {}).then(res => {
                    // console.log("groupList is " + JSON.stringify(res))
                    let options = []
                    let a = {}
                    let b = {}
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.groupName,
                        })
                        a["id" + v.id] = v.groupName
                        b["id" + v.id] = v.groupType
                    })
                    this.searchOptions.userGroupOption = options
                    this.groupClass = a
                    this.groupTypeClass = b
                })
            },
            /* 添加用户 */
            addUser() {
                if (!this.addUserInfo.username || !this.addUserInfo.password
                    || !this.addUserInfo.password2 || !this.addUserInfo.groupId
                    || this.addUserInfo.password !== this.addUserInfo.password2) {
                    this.$message.error("信息为空或者两次密码不一致")
                    return
                }
                let that = this
                that.ipProxySelection.forEach(item => {
                    that.addUserInfo.proxyIds.push(item.id)
                })
                // console.log("addUserInfo is " + JSON.stringify(that.addUserInfo))
                that.$post(that.$uri.user.add, that.addUserInfo).then(res => {
                    that.$message.success("添加成功")
                    that.addUserPopShow = false
                    that.getUserList()
                })
            },
            /* 修改用户弹窗 */
            changeUserPop(row) {
                // console.log("changeUser row is " + JSON.stringify(row))
                this.changeUserInfo.id = row.id
                this.changeUserInfo.username = row.username
                this.changeUserInfo.groupId = row.groupId
                // this.changeUserInfo.groupType = row.groupType
                if (row.aging) {
                    this.changeUserInfo.aging = row.aging
                } else {
                    this.changeUserInfo.aging = -1
                }
                this.getIpPorxyList()
                this.getUserIpProxy(this.changeUserInfo.id)
                this.changeUserPopShow = true
                if (this.groupTypeClass['id' + this.changeUserInfo.groupId] == 2) {
                    this.$nextTick().then(() => {
                        this.ipProxyTableHeight2 = window.innerHeight - this.$refs.ipProxyMultipleTable2.$el.offsetTop - 100;
                    })
                }
            },
            /* 修改用户 */
            changeUser() {
                this.$post(this.$uri.user.infoSave, this.changeUserInfo).then(res => {
                    if (res.success == true) {
                        let proxyIds = []
                        this.ipProxySelection.forEach(item => {
                            proxyIds.push(item.id)
                        })
                        this.$post(this.$uri.user.userProxy, {
                            id: this.changeUserInfo.id,
                            proxyIds: proxyIds
                        }).then(res => {
                            if (res.success == true) {
                                this.$message.success("修改成功")
                            } else {
                                this.$message.success("修改失败")
                            }
                        })
                    } else {
                        this.$message.success("修改失败")
                    }
                    this.changeUserPopShow = false
                    this.getUserList()
                })
            },
        },
        mounted() {
            this.getUserList()
            this.getGroupList()
            this.$nextTick().then(() => {
                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
            })
        }
    };
</script>

<style lang="less" scoped>
    .dev-list {
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .search-main-item {
                        /*width: 24%;*/
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                            margin-right: 6px;
                        }
                        .item-input {
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 0 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }

    .ipproxy-list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
        .list-bottom-btn {
            display: flex;
            flex-direction: row;
        }
    }
</style>